import {
  Accessibility,
  LocalHospital,
  NoteAlt,
} from "@mui/icons-material";
import { ReactElement } from "react";
import { useMedicalCareContext } from "../../../../contexts/MedicalCareContext";
import {
  UnderlineTab,
  UnderlineTabs,
} from "src-next/shared/ui/navigation/UnderlineTabs";

/**
 * Etapas do atendimento.
 * Cada etapa vira uma aba (Tab) com o seu ícone correspondente,
 * substituindo o antigo Stepper por uma navegação em abas mais moderna.
 */
const steps: { label: string; icon: ReactElement }[] = [
  { label: "Atendimento", icon: <Accessibility /> },
  { label: "Intervenções", icon: <LocalHospital /> },
  { label: "Documentos e assinatura", icon: <NoteAlt /> },
];

/**
 * Navegação das telas do atendimento em formato de abas.
 * Continua controlada pelo mesmo estado global (activeStep / setActiveStep)
 * do MedicalCareContext, sem criar novo estado.
 * Estilo das abas: componente compartilhado UnderlineTabs.
 */
export function StepArea() {
  const { activeStep, setActiveStep } = useMedicalCareContext();

  return (
    <UnderlineTabs
      value={activeStep}
      onChange={(_, value) => setActiveStep(value)}
      // fullWidth aproveita todo o espaço horizontal disponível,
      // evitando espaços em branco excessivos entre as abas.
      variant="fullWidth"
      aria-label="Navegação das etapas do atendimento"
    >
      {steps.map((step) => (
        <UnderlineTab
          key={step.label}
          icon={step.icon}
          iconPosition="start"
          label={step.label}
        />
      ))}
    </UnderlineTabs>
  );
}
